<template>
  <div
    class="offcanvas offcanvas-fullscreen-sm-down offcanvas-end"
    tabindex="-1"
    id="offcanvaInfo"
    ref="offcanvaInfo"
    data-bs-backdrop="static"
  >
    <!-- data-bs-backdrop="static" -->
    <div class="bg-top-nav border offcanvas-header py-2">
      {{ $t('Product Detail')  }}
      <button
        type="button"
        style="font-size: small;"
        class="btn-close shadow-none text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      />
    </div>

    <div
      class="offcanvas-body"
      v-if="loading"
    >
      <placeholder-content :is-load="true" />
    </div>
    <div
      class="offcanvas-body"
      v-else-if="!hasPermission"
    >
      <access-denied/>
    </div>
    <div
      class="offcanvas-body p-0"
      v-else
    >
      <div
        class="border-bottom py-2 px-3"
      >
        <div class="d-flex">
          <!-- <img
            :src="$storeIndex.getImageUrl(data.thumbnail_url)"
            @error="$storeIndex.onImageError"
            class="images_box_info rounded me-2"
          > -->
          <div class="row g-3 py-2">
            <b style="font-size: 18px;" class="mt-2">
              {{ data.name }}
            </b>
            <div
              class="d-flex mt-0 "
              style="font-size: 13px;"
            >
              <label
                class="pe-2"
              >
                {{ $t('Status')  }}
                <span
                  :class="['badge', data.active? 'bg-success': 'bg-danger']"
                >
                  {{ data.active? $t('Active'): $t('Inactive') }}
                </span>
              </label>
              <label
                class="pe-2"
              >
                {{ $t('Last Update') + ': ' + formatDateTime(data.updated_at) }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div
        class="card m-3"
      >
        <div class="card-header">
          <i class="fa-solid fa-circle-info me-2" />
          {{ $t('Product Information') }}
        </div>
        <div class="card-body pb-0">
          <div class="row" style="font-size: 13px;">
            <div class="col-6 col-md-3 mb-3">
              <b>
                {{ $t('Barcode') + ':' }}
              </b>
            </div>
            <div
              class="col-6 col-md-9 mb-3"
              v-if="data.barcode"
            >
              <vue3-barcode
                style="overflow-x: hidden !important; margin-right: 0px;"
                :value="data.barcode"
                format="CODE128"
                :display-value="false"
                :text-align="'left'"
                :font-size="12"
                :width="2"
                :height="20"
                margin="0"
              />
            </div>
            <div
              v-else
              class="col-6 col-md-9 mb-3"
            >
              -
            </div>
            <div class="col-6 col-md-3 mb-3">
              <b>
                {{ $t('Code') + ':' }}
              </b>
            </div>
            <div
              class="col-6 col-md-3 mb-3"
            >
              {{ data.code }}
            </div>
            <div class="col-6 col-md-3 mb-3">
              <b>
                {{ $t('Type') + ':' }}
              </b>
            </div>
            <div
              class="col-6 col-md-3 mb-3"
            >
              <span
                class='badge'
                :class="[data.type == 'Configurale'? 'bg-info text-dark': 'bg-secondary text-white']"
              >
                {{ $t(data.type) }}
              </span>
            </div>
            <div class="col-6 col-md-3 mb-3">
              <b>
                {{ $t('Category') + ':' }}
              </b>
            </div>
            <div
              class="col-6 col-md-3 mb-3"
            >
              {{ $t(data.category) }}
            </div>
            <div class="col-6 col-md-3 mb-3">
              <b>
                {{ $t('VAT') + ':' }}
              </b>
            </div>
            <div
              class="col-6 col-md-3 mb-3"
            >
              {{ $t(data.tax_status) }}
            </div>
            <div class="col-6 col-md-3 mb-3">
              <b>
                {{ $t('Price') + ':' }}
              </b>
            </div>
            <div
              class="col-6 col-md-3 mb-3"
            >
              {{ formatDigit(data.price) }}
            </div>
            <div class="col-6 col-md-3 mb-3">
              <b>
                {{ $t('Unit Cost') + ':' }}
              </b>
            </div>
            <div
              class="col-6 col-md-3 mb-3"
            >
              {{ formatDigit(data.cost) }}
            </div>
            <div class="col-6 col-md-3 mb-3">
              <b>
                {{ $t('In Stock') + ':' }}
              </b>
            </div>
            <div
              class="col-6 col-md-3 mb-3"
            >
              <span
                :class="['badge', data.in_stock? 'bg-success': 'bg-secondary']"
              >
                <i :class="['fa-solid' , data.in_stock? 'fa-check': 'fa-xmark']" />
                {{ data.in_stock? $t('Yes'): $t('No') }}
              </span>
            </div>
            <div class="col-6 col-md-3 mb-3">
              <b>
                {{ $t('Recommend') + ':' }}
              </b>
            </div>
            <div
              class="col-6 col-md-3 mb-3"
            >
              <span
                :class="['badge', data.recommend? 'bg-success': 'bg-secondary']"
              >
                <i :class="['fa-solid' , data.recommend? 'fa-check': 'fa-xmark']" />
                {{ data.recommend? $t('Yes'): $t('No') }}
              </span>
            </div>
            <div class="col-6 col-md-3 mb-3">
              <b>
                {{ $t('Serving Size') + ':' }}
              </b>
            </div>
            <div
              class="col-6 col-md-3 mb-3"
              v-if="data.size_value && data.size_unit"
            >
              {{ data.size_value + ' ' + $t(data.size_unit) }}
            </div>
            <div
              class="col-6 col-md-3 mb-3"
              v-else
            >
              -
            </div>
            <div class="col-6 col-md-3 mb-3">
              <b>
                {{ $t('Sales Unit') + ':' }}
              </b>
            </div>
            <div
              class="col-6 col-md-3 mb-3"
            >
              {{ $t(data.unit) }}
            </div>
            <div class="col-6 col-md-3 mb-3">
              <b>
                {{ $t('Image') + ':' }}
              </b>
            </div>
            <div
              class="col-6 col-md-3 mb-3"
              v-if="data.thumbnail_url && data.image_url"
            >
              <img
                @click="showImage(data.image_url)"
                :src="$storeIndex.getImageUrl(data.thumbnail_url)"
                @error="$storeIndex.onImageError"
                style="cursor: pointer;"
                class="img-table"
              >
            </div>
            <div
              class="col-6 col-md-3 mb-3"
              v-else
            >
              -
            </div>
            <div class="col-6 col-md-3 mb-3">
              <b>
                {{ $t('Create By') + ':' }}
              </b>
            </div>
            <div class="col-6 col-md-3 mb-3">
              {{ data.created_by }}
            </div>
          </div>
          <template
            v-if="data.description"
          >
            <h6 class="border-bottom card-title pb-2">
              {{ $t('Description') }}
            </h6>
            <div
              class="card-text pt-0 ql-editor"
              v-html="data.description"
            />
          </template>
        </div>
      </div>
    </div>
    <div
      class="bg-light border-top justify-content-center modal-footer py-2"
      v-if="!loading && hasPermission"
    >
      <div class="btn-group dropdown">
        <button
          type="button"
          class="btn btn-sm btn-primary dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          @mouseenter="isHovered = true"
          @mouseleave="isHovered = false"
        >
          <i class="fa-solid fa-ellipsis me-1" :class="isHovered? 'fa-fade': ''" />
          {{ $t('More Action') }}
        </button>
        <ul class="dropdown-menu">
          <li>
            <a
              class="dropdown-item"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              @click="() => {
                $parent.offcanvasFroms.open = true;
                $parent.offcanvasFroms.id = id;
                $parent.offcanvasFroms.type = 'EDIT';
              }"
            >
              <i class="fa-solid fa-square-pen" />
              {{ $t('Edit') }}
            </a>
          </li>
          <li>
            <a
              class="dropdown-item"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              @click="() => {
                $parent.offcanvasRecipeFrom.open = true;
                $parent.offcanvasRecipeFrom.id = id;
              }"
            >
              <i class="fa-solid fa-book-open" />
              {{ $t('Recipe') }}
            </a>
          </li>
          <li>
            <a
              class="dropdown-item"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              @click="() => {
                $parent.offcanvasModifierForm.open = true;
                $parent.offcanvasModifierForm.id = id;
              }"
            >
              <i class="fa-solid fa-sliders" />
              {{ $t('Modifier') }}
            </a>
          </li>
          <li>
            <a
              class="dropdown-item"
              @click="handleDelete()"
            >
              <i class="fa-solid fa-trash-can" />
              {{ $t('Delete') }}
            </a>
          </li>
        </ul>
      </div>
      <button
        type="button"
        data-bs-dismiss="offcanvas"
        class="border-dark-subtle btn-sm btn btn-light me-2 ms-2"
      >
        {{ $t('Cancel') }}
      </button>
    </div>
  </div>
  <div
    class="modal fade"
    id="modalImage"
    ref="modalImage"
    aria-labelledby="modalImageLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <img
        :src="$storeIndex.getImageUrl(modalImage.image)"
        @error="$storeIndex.onImageError"
        class="d-block w-100"
        data-bs-dismiss="modal"
      >
    </div>
  </div>
</template>

<script lang="js">
import AccessDenied from "@/plugins/AccessDenied.vue";
import Vue3EasyDataTable from 'vue3-easy-data-table';
import { Products } from '@/services/endpoint/products.service';
import { Inventories, InventoryLots } from '@/services/endpoint/inventories.service';
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import Ladda from '@/plugins/Ladda.vue';
import moment from "moment";
import numeral from 'numeral';
import Popper from "vue3-popper";
import Vue3Barcode from 'vue3-barcode'

export default {
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      hasPermission: false,
      modalImage: {
        open: false,
        image: ''
      },
      isHovered: false,
      loading: true,
      data: {
        name: '',
        code: '',
        quantity: 0,
        cost: 0,
        unit_id: '1',
      },
    }
  },
  components: {
    AccessDenied,
    Vue3EasyDataTable,
    PlaceholderContent,
    Ladda,
    Popper,
    Vue3Barcode
  },
  methods: {
    async showImage(image) {
      if (!image) {
        return;
      }
      this.modalImage.image = image;
      $(this.$refs.modalImage).modal('show');
    },
    bodyItemClassNameFunction(column, rowNumber) {
      let className = 'align-top py-1 px-2 border-0';
      const columnCenter = ['received_date', 'expiry_date', 'created_at'];
      const columnEnd = ['price', 'cost', 'size_value', 'unit'];
      if (columnCenter.includes(column)) {
        className += ' text-center';
      }
      if (columnEnd.includes(column)) {
        className += ' text-end';
      }
      return className;
    },
    formatDigit(value) {
      if ((value < 0.01) && value != 0) {
        return numeral(value).format("0,0.0000");
      }
      return numeral(value).format("0,0.00");
    },
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.0000");
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    async getInfoData() {
      this.loading = true;
      await Products.getInfo(this.id).then(res => {
        this.data = res.data.data;
        this.hasPermission = true;
        this.loading = false;
      }).catch(err => {
        if (err?.response?.status === 403) {
          this.hasPermission = false;
        }
        this.loading = false;
			  throw err;
      });
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY');
    },
    formatDateTime(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss');
    },
    async handleDelete() {
      try {
        let self = this;
        let title = this.$t("Delete Product") + '?';
        let html = this.$t("You will not be able to undo this action.");
        let confirmButtonText =
          '<i class="fas fa-check-circle me-1"></i>' + this.$t("Confirm");
        this.$swal({
          icon: "warning",
          iconColor: "#FF7043",
          title: title,
          // text: "You will not be able to undo this action.",
          html: html,
          showCancelButton: true,
          cancelButtonText: this.$t("Cancel"),
          confirmButtonText: confirmButtonText,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary me-2",
            cancelButton: "btn btn-danger",
          },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          preConfirm: async function () {
            return Products.delete(self.id)
              .then((response) => {
                self.$parent.fetchData();
                self.$toast.success("<B>" + self.$t('Success') + "</B>\n" + self.$t('Delete Product Success!'));
                $(self.$refs.offcanvaInfo).offcanvas('hide');
              })
              .catch((error) => {
                if (error?.response?.status === 403) {
                  self.$swal.update({
                    title: self.$t('Access Denied'),
                    confirmButtonText: '<i class="fas fa-redo me-1"></i>' + self.$t("Try again"),
                    text: self.$t('You do not have permission to access this page.')
                  });
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else {
                  self.$toast.warn(error?.response?.data?.message);
                }
              })
          },
        });
      } catch (error) {
      }
    },
    async handleEditLot() {
      try {
        let self = this;
        let title = this.$t("Delete Lot") + '?';
        let html = this.$t("Deleting this lot may affect past cost calculations");
        let confirmButtonText =
          '<i class="fas fa-check-circle me-1"></i>' + this.$t("Confirm");
        this.$swal({
          icon: "warning",
          iconColor: "#FF7043",
          title: title,
          // text: "You will not be able to undo this action.",
          html: html,
          showCancelButton: true,
          cancelButtonText: this.$t("Cancel"),
          confirmButtonText: confirmButtonText,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary me-2",
            cancelButton: "btn btn-danger",
          },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          preConfirm: async function () {
            return Inventories.delete(self.inventoryId)
              .then((response) => {
                self.$parent.fetchData();
                self.$toast.success("<B>" + self.$t('Success') + "</B>\n" + self.$t('Delete Product Success!'));
                $(self.$refs.offcanvaInfo).offcanvas('hide');
              })
              .catch((error) => {
                if (error?.response?.status === 403) {
                  self.$swal.update({
                    title: self.$t('Access Denied'),
                    confirmButtonText: '<i class="fas fa-redo me-1"></i>' + self.$t("Try again"),
                    text: self.$t('You do not have permission to access this page.')
                  });
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else {
                  self.$toast.warn(error?.response?.data?.message);
                }
              })
          },
        });
      } catch (error) {
      }
    },
    async handleDeleteLot() {
      try {
        let self = this;
        let title = this.$t("Delete Lot") + '?';
        let html = this.$t("Deleting this lot may affect past cost calculations");
        let confirmButtonText =
          '<i class="fas fa-check-circle me-1"></i>' + this.$t("Confirm");
        this.$swal({
          icon: "warning",
          iconColor: "#FF7043",
          title: title,
          // text: "You will not be able to undo this action.",
          html: html,
          showCancelButton: true,
          cancelButtonText: this.$t("Cancel"),
          confirmButtonText: confirmButtonText,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary me-2",
            cancelButton: "btn btn-danger",
          },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          preConfirm: async function () {
            return InventoryLots.delete(self.inventoryId)
              .then((response) => {
                self.$parent.fetchData();
                self.$toast.success("<B>" + self.$t('Success') + "</B>\n" + self.$t('Delete Product Success!'));
                $(self.$refs.offcanvaInfo).offcanvas('hide');
              })
              .catch((error) => {
                if (error?.response?.status === 403) {
                  self.$swal.update({
                    title: self.$t('Access Denied'),
                    confirmButtonText: '<i class="fas fa-redo me-1"></i>' + self.$t("Try again"),
                    text: self.$t('You do not have permission to access this page.')
                  });
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else {
                  self.$toast.warn(error?.response?.data?.message);
                }
              })
          },
        });
      } catch (error) {
      }
    },
  },
  async mounted() {
    $(this.$refs.offcanvaInfo).offcanvas('show');

    $(this.$refs.offcanvaInfo).on('shown.bs.offcanvas',async () => {
      try {
        await this.getInfoData();
      } catch (err) {
      }
    });

    $(this.$refs.offcanvaInfo).on('hidden.bs.offcanvas', () => {
      this.$emit('close-info');
      // this.$parent.formInfo.open = false;
    });
  },
  computed: {

  },
  watch: {
  }
}
</script>
